module.exports = __webpack_public_path__ + "img/icon_cat_action.3d1f4bc.png";